import "./MoreInformation.css";
import callOptionsEarlyImage from "../../img/callOptionsEarly.png";

export const CallOptionsEarly = (
  <div className="info-container flex flex-row mr-auto ml-auto">
    <div className="info-column flex flex-column ">
      <text className="sub-title">Call options – early leaver</text>
      <text className="paragraph">
        Considering whether vested and unvested shares should be subject to call
        options and determining the prices thereof provides endless
        possibilities and allows you to be creative.
      </text>
      <text className="paragraph">
        Without obstructing your inner Van Gogh, we’ll provide you with some
        general principles to consider while making your decisions.
      </text>
      <text className="paragraph ml-4">
        - Call option prices for vested shares should be higher than call option
        prices for unvested shares because vested shares are ‘earned’ and
        unvested shares are ‘not earned’.
      </text>
      <text className="paragraph ml-4">
        - Good leavers should get a better price than early leavers and early
        leavers should get a better price than bad leavers.
      </text>
      <text className="paragraph ml-4">
        - Fair market value (FMV) is not a fixed price. FMV can be a point of
        discussion later when there is disagreement between the parties on the
        value of the underlying asset (shares). If parties do not agree, an
        independent third party will determine the FMV.
      </text>
      <text className="paragraph ml-4">
        - Often, in an early stage, founders will not have enough funds to
        exercise their call options if the prices are fairly high, this can also
        be the case with the fair market value.
      </text>
    </div>
    <div className="info-column flex">
      <img src={callOptionsEarlyImage} className="info-image mr-auto ml-auto" />
    </div>
  </div>
);
